import React from "react";
import { useSelector } from "react-redux";
import ErrorPage from "./ErrorPage";

// Two ways to land here, and they need different copy. A logged-out visitor
// really does just need to sign in, which is the 403 default in ErrorPage.
// A logged-in user bounced by AdminRoutes is already signed in -- telling them
// to sign in again is a dead end, so point them at their own dashboard instead.
export default function AccessDeniedPage() {
  const user = useSelector((state) => state.user);

  if (!user) return <ErrorPage code={403} />;

  return (
    <ErrorPage
      code={403}
      message="Your account doesn't have permission to view this page."
      primaryAction={{ label: "Go to your dashboard", to: "/dashboard/epks" }}
    />
  );
}
